import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, setToken, errMsg } from "@/lib/api";

const field = "w-full bg-white border border-border-subtle px-4 py-3 text-charcoal text-[0.95rem] focus:border-navy outline-none transition-colors";

const AdminLogin = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (forgot) {
        await api.post("/auth/forgot-password", { email });
        toast.success("If that email is registered, a reset link has been sent.");
        setForgot(false);
      } else {
        const { data } = await api.post("/auth/login", { email, password });
        setToken(data.token);
        nav("/admin");
      }
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "#F7F4EE" }}>
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 justify-center mb-8">
          <img src="/brand/logo.png" alt="Arun Gupta & Co." className="h-14 w-14 object-contain" />
          <div className="text-left">
            <div className="font-serif text-navy text-2xl leading-none">Arun Gupta &amp; Co.</div>
            <div className="overline mt-1" style={{ fontSize: "0.55rem" }}>Content Admin</div>
          </div>
        </div>
        <form onSubmit={submit} className="bg-white border border-border-subtle p-8" data-testid="admin-login-form">
          <h1 className="font-serif text-navy text-3xl mb-6">{forgot ? "Reset password" : "Sign in"}</h1>
          <label className="block text-xs font-semibold tracking-wider uppercase text-charcoal/70 mb-2">Email</label>
          <input className={field} type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email-input" />
          {!forgot && (
            <>
              <label className="block text-xs font-semibold tracking-wider uppercase text-charcoal/70 mb-2 mt-5">Password</label>
              <input className={field} type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password-input" />
            </>
          )}
          <button type="submit" className="btn-solid mt-7 w-full justify-center" disabled={busy} data-testid="admin-login-submit">
            {busy ? <Loader2 size={16} className="animate-spin" /> : forgot ? "Send reset link" : "Sign in"}
          </button>
          <button type="button" onClick={() => setForgot(!forgot)} className="mt-5 text-sm text-charcoal/60 hover:text-navy link-underline w-full text-center" data-testid="admin-forgot-toggle">
            {forgot ? "Back to sign in" : "Forgot password?"}
          </button>
        </form>
        <div className="text-center mt-6">
          <Link to="/" className="text-sm text-charcoal/50 hover:text-navy link-underline">← Back to website</Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
